<template>
    <div class="ask-topic">
        <Header title="添加话题" v-if="!isWx" :rightContent="rightContent"  />
        <div class="main" :style="{'padding-top': isWx?'20px':'80px'}">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="initTopicList"
                :van-clearfix="true"
                class="van-clearfix"
            >
                <van-cell v-for="item in topicList" :key="item.id">
                    <div class="item" @click="jumpDet(item.id, item.name)">
                        <van-image 
                            class="bgimg"
                            lazy-load
                            fit="cover"
                            width="100%"
                            height="100%"
                            :src="item.img ? item.img : ''"
                        />
                        <span class="bg" :style="{'background-color': item.color }"></span>
                        <div class="info">
                            <p class="title van-multi-ellipsis--l2">{{item.name}}</p>
                            <div class="join flex">
                                <span class="flex_1">{{item.ask_num}}个问题</span>
                                <span class="flex_1">{{item.nums}}赞过</span>
                            </div>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { Header } from '@/components'
import { getAskTopicList } from '@/request/api'
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components :{
        Header
    },
    data() {
        return {
            rightContent: {
                path: '/askSearch',
                icon: require("@/assets/img/icon_search.png")
            },
            topicList: [],
            topicPage: 1,
            loading: false, // 加载中
            finished: false, // 加载完毕
            isWx: true
        }
    },
    methods: {
        // 获取推荐列表
        initTopicList() {
            getAskTopicList({
                page: this.topicPage,
                pcount: 8,
            }).then( res => {
                let {list, error_code} = res;
                if(error_code === 0) {
                    if(error_code === 0) {
                        if (list.length === 0 || !list) {
                            this.finished = true;
                            return false;
                        }
                        list.map(item => this.topicList.push(item));
                        this.topicPage++;
                        this.loading = false;
                    }
                }
            }).catch( error => {
                console.log(error)
            })
        },
         // 话题详情
        jumpDet(id, name) {
           navigate({ path: 'askTopicDet', query: { id: id, name: name } });
        },
    },
    created() {
        this.isWx = checkWx();
        // this.initTopicList();
    }
}
</script>

<style lang="less" scoped>
    .ask-topic {
        background-color: #F8F8F8;
        width: 100%;
        height: 100%;
        .main {
            width: 100%;
            height: 100%;
            padding: 5rem 20px 20px;
            box-sizing: border-box;
        }
    }
    .item{
        height:6.25rem;
        margin-right: 0.5rem;
        position: relative;
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
        .bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 300;
            opacity: 0.7;
        }
        .bgimg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 200;
        }
    }
    .item .info {
        height: 6.25rem;
        box-sizing: border-box;
        padding: 0.5rem;
        position: relative;
        z-index: 400;
        background-size: 100% 100%;
    }
    .item > div .title {
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        overflow: hidden;
        box-sizing: border-box;
        padding-left: 1.375rem;
        background: url("../../../../../assets/img/icon_msg.png") no-repeat top left;
        background-size: 1.25rem 1.25rem;
    }
    .item > div .join {
        position: absolute;
        width: 100%;
        height: 1.25rem;
        left: 0;
        bottom: 0.25rem;
        overflow: hidden;
    }
    .item > div .join span {
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #fff;
        transform: scale(0.8);
    }
    .van-cell {
        background-color: transparent !important;
        width: 48%;
        float: left;
    }
    .van-cell:nth-child(2n) {
        margin-left: 4%;
    }
    .van-list {
        padding-bottom: 30px;
        position: relative;
    }
    .van-list::after {
        content: "";
        display: block;
        clear: both;
    }
</style>